import { useState } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '@/components/molecules/SearchBar';
import BasketCount from '@/components/atoms/BasketCount';
import ThemeToggle from '@/components/atoms/ThemeToggle';
import { useBasket } from '@/hooks/useBasket';

export default function DJNavbar() {
  const [searchValue, setSearchValue] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { totalItems } = useBasket();

  return (
    <nav className="sticky top-0 z-50 bg-black/90 border-b-2 border-dj-red">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <h1 className="text-2xl font-bold">
              <span className="text-white">D</span>
              <span className="text-dj-red">&</span>
              <span className="text-white">J RECORDS</span>
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="text-dj-silver hover:text-dj-blue transition-colors">
              Home
            </Link>
            <Link to="/shop" className="text-dj-silver hover:text-dj-blue transition-colors">
              Shop
            </Link>
            <Link to="/services" className="text-dj-silver hover:text-dj-blue transition-colors">
              Services
            </Link>
            <Link to="/enquiries" className="text-dj-silver hover:text-dj-blue transition-colors">
              Enquiries
            </Link>
            <Link to="/about" className="text-dj-silver hover:text-dj-blue transition-colors">
              About
            </Link>
            <Link to="/contact" className="text-dj-silver hover:text-dj-blue transition-colors">
              Contact
            </Link>
          </div>

          {/* Right Side: Search, Theme, Basket */}
          <div className="flex items-center space-x-4">
            <div className="hidden md:block w-64">
              <SearchBar value={searchValue} onChange={setSearchValue} />
            </div>
            <ThemeToggle />
            <Link to="/basket" className="relative">
              <i className="fa-solid fa-shopping-basket text-dj-silver text-xl" />
              <BasketCount count={totalItems} className="absolute -top-1 -right-2" />
            </Link>
            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-dj-silver hover:text-dj-blue"
            >
              <i className={`fa-solid ${mobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-dj-dark border-t border-[#333]">
          <div className="px-4 py-3 space-y-3">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-dj-silver hover:text-dj-blue transition-colors"
            >
              Home
            </Link>
            <Link
              to="/shop"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-dj-silver hover:text-dj-blue transition-colors"
            >
              Shop
            </Link>
            <Link
              to="/services"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-dj-silver hover:text-dj-blue transition-colors"
            >
              Services
            </Link>
            <Link
              to="/enquiries"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-dj-silver hover:text-dj-blue transition-colors"
            >
              Enquiries
            </Link>
            <Link
              to="/about"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-dj-silver hover:text-dj-blue transition-colors"
            >
              About
            </Link>
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-dj-silver hover:text-dj-blue transition-colors"
            >
              Contact
            </Link>
            <div className="pt-2">
              <SearchBar value={searchValue} onChange={setSearchValue} />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
